import React, { useState } from "react"
import logo from "../../assets/imgfooter.png"
import Bg from "../../assets/solaria-header1.jpg"
import {AiFillEye, AiFillEyeInvisible} from 'react-icons/ai';

export default function Login() {

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!username.trim() || !password){
      alert('Please isi dulu username dan passwordnya boss.');
      return;
    }
      setPassword('');
  }
  const handleTogglePassword = () =>{
    setShowPassword(!showPassword);
  };

    return (
      <>
        
       <div className="w-full lg:w-full flex items-center justify-center bg-cover relative">

       <div className="absolute inset-0 bg-cover bg-center z-0">
          <img className="w-full h-screen object-cover"
               src={Bg}
               alt="Background Login"
          />
       <div className="absolute inset-0 bg-black bg-opacity-50 z-10">
        <div className="mx-auto max-w-md lg:flex lg:rounded-2xl bg-gray-200 flex-1 
                        min-h-screen flex flex-col justify-center 
                        shadow-lg px-10 py-12 lg:px-8 bg-gray-200 bg-opacity-90 z-2 p-8 space-y-8 ">

          <div id="/admin" className="sm:mx-auto sm:w-full sm:max-w-sm w-full max-w-md md:block relative">
          
            <img
              alt="Solaria Resto Administrator"
              src={logo}
              className="mx-auto h-28 w-auto"
            />
            <h2 className="mt-10 text-center text-2xl/9 font-bold tracking-tight text-gray-900">
              Administrator
            </h2>
          
          </div>
          <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
            <form action="#" method="POST" className="space-y-6">
              <div>
                <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                  
                </label>
                <div className="mt-2">
                  <input
                    id="username"
                    name="username"
                    type="text"
                    placeholder="Username"
                    value={username}
                    autoFocus
                    required
                    onChange={(e)=> setUsername(e.target.value)}
                    className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                  />
                  
                </div>
              </div>
  
              <div>
                <div className="flex items-center justify-between">
                  <label htmlFor="password" className="block text-sm/6 font-medium text-gray-900">
                  </label>
                  <div className="text-sm">
                    <a href="/error404" className="font-semibold text-pink-800 hover:text-pink-500">
                      Forgot Password?
                    </a>
                  </div>
                </div>
                <div className="mt-2">
                  <input
                    id="password"
                    type={showPassword ? 'text':'password'}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Password"
                    required
                    autoComplete="current-password"
                    className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                  />
                  
                </div>
              </div>
              <div>
                <button
                  type="submit"
                  className="flex w-full justify-center rounded-md bg-pink-800 px-3 py-1.5 text-sm/6 font-semibold text-white shadow-xs hover:bg-pink-600 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                >
                  Sign In
                </button>
              </div>
            </form>
  
            {/* <p className="mt-10 text-center text-sm/6 text-gray-500">
              Don't have an account?{' '}
              <a href="#" className="font-semibold text-indigo-600 hover:text-indigo-500">
                Sign Up
              </a>
            </p> */}
          </div>
        </div>
          </div>
        </div>
            </div>
      </>
      
    )
  }
  